import * as React from "react";
const SvgFiRrUserMdChat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-md-chat_svg__a)">
      <path
        fill="#062147"
        d="M23.994 4.752A4.98 4.98 0 0 0 19.248.006c-1.328-.068-2.611.42-3.603 1.363a5.33 5.33 0 0 0-1.646 3.845v2.458c0 1.6 1.037 2.328 2 2.328h2.782a5.34 5.34 0 0 0 3.849-1.647c.944-.99 1.429-2.27 1.364-3.6m-2.812 2.222A3.33 3.33 0 0 1 18.782 8l-2.715.035S16 7.943 16 7.672V5.214c0-.902.373-1.776 1.024-2.396.557-.53 1.396-.813 2.126-.813a2.984 2.984 0 0 1 2.846 2.846c.038.778-.251 1.533-.813 2.124zM2.999 6A6.008 6.008 0 0 1 11.4.5a1 1 0 0 1-.8 1.832A4.004 4.004 0 0 0 5 6a4.004 4.004 0 0 0 5.6 3.668.996.996 0 0 1 1.316.516A1 1 0 0 1 11.4 11.5 6.007 6.007 0 0 1 2.999 6m17 17a1 1 0 1 1-2 0 7.01 7.01 0 0 0-4-6.324v2.496c1.164.413 2 1.524 2 2.828v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-2 0v1a1 1 0 1 1-2 0v-1c0-1.304.836-2.415 2-2.828v-3.1a7 7 0 0 0-1-.072h-2c-.695 0-1.366.102-2 .292v2.977a1.999 1.999 0 0 1-1 3.732 2 2 0 0 1-1-3.732V17.26a7 7 0 0 0-3 5.741 1 1 0 1 1-1.999 0c0-4.964 4.037-9 9-9h2c4.963 0 8.999 4.036 8.999 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-md-chat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserMdChat;
